/*
 * @Author: keman.chen
 * @Date: 2023-08-25 11:35:51
 * @LastEditTime: 2023-10-08 16:00:37
 * @LastEditors: keman.chen
 * @Description: 统一上报格式
 * @FilePath: /monitor/packages/core/src/transformData.ts
 */
import { BREADCRUMBTYPES, ERRORTYPES, globalVar, HTTP_CODE } from '@tr-infra/pilot-shared'
import { getLocationHref, getTimestamp, Severity, fromHttpStatus, SpanStatus, interceptStr } from '@tr-infra/pilot-utils'
import { ReportDataType, MITOHttp, Replace, ResourceErrorTarget } from '@tr-infra/pilot-types'
import { getRealPath } from './errorId'
import { breadcrumb } from './breadcrumb'

export function httpTransform(data: MITOHttp): ReportDataType {
  let message = ''
  const isError = data.status === 0 || data.status === HTTP_CODE.BAD_REQUEST || data.status > HTTP_CODE.UNAUTHORIZED
  const { duration, time, method, traceId, type, status, sTime, eTime } = data
  const name = `${type}--${method}`
  if (status === 0) {
    message =
      duration <= globalVar.crossOriginThreshold ? 'http请求失败，失败原因：跨域限制或域名不存在' : 'http请求失败，失败原因：超时'
  } else {
    message = fromHttpStatus(status)
  }
  message = message === SpanStatus.Ok ? message : `${message} ${getRealPath(data.url)}`
  return {
    type, //ERRORTYPES.FETCH_ERROR,
    url: getLocationHref(),
    time,
    sTime,
    eTime,
    duration,
    level: isError ? Severity.Error : Severity.Info,
    message,
    name,
    traceId,
    method,
    reqUrl: data.url,
    reqData: data.reqData || '',
    status
  }
}

const resourceMap = {
  img: '图片',
  script: 'js脚本'
}

export function resourceTransform(target: ResourceErrorTarget): ReportDataType {
  return {
    type: ERRORTYPES.RESOURCE_ERROR,
    url: getLocationHref(),
    message: '资源地址: ' + (interceptStr(target.src, 120) || interceptStr(target.href, 120)),
    level: Severity.Error,
    time: getTimestamp(),
    name: `${resourceMap[target.localName] || target.localName}加载失败`
  }
}

export function handleConsole(data: Replace.TriggerConsole): void {
  if (globalVar.isLogAddBreadcrumb) {
    breadcrumb.push({
      type: BREADCRUMBTYPES.CONSOLE,
      category: breadcrumb.getCategory(BREADCRUMBTYPES.CONSOLE),
      data,
      level: Severity.fromString(data.level)
    })
  }
}
